import { Box, Paper, Typography } from '@mui/material';
import React, { useState } from 'react'; // Import useState
import { Link } from 'react-router-dom';
import { Header } from '../../../components/singleComponents/headers';

import { TabClient } from '../../../components/singleComponents/tabs/TabClient';
import { About } from './about/About';
import { Personalization } from './personalization/Personalization';
import { BoxConfigStyled, RootStyled } from './SettingsAdmin.styles';

export function SettingsAdmin() {
  const [activeTab, setActiveTab] = useState(0); // Estado para a aba ativa

  const headings = [
    { title: 'SOBRE A CONTA', value: 0 },
    { title: 'PERSONALIZAÇÃO DO SISTEMA', value: 1 },
  ];

  const panel = [
    { value: 0, component: <About /> },
    { value: 1, component: <Personalization /> },
  ];

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <>
      <Header page="Configurações" />
      <RootStyled>
        <BoxConfigStyled>
          <Box component={Paper}>
            {/* Passa o estado da aba e a função de mudança */}
            <TabClient
              headings={headings}
              panels={panel}
              activeTab={activeTab}
              onTabChange={handleTabChange}
            />
          </Box>
        </BoxConfigStyled>
        <div style={{ margin: 16, display: 'flex' }}>
          <Typography>
            <Link to="/">Termos de uso </Link>e{' '}
            <Link to="/"> política de privacidade</Link>
          </Typography>
        </div>
      </RootStyled>
    </>
  );
}
